import PropTypes from "prop-types";
import React from "react";

/**
 * If this component is iterated over some array then pass the unique `id` prop
 * `id` must be somethong that uniquely identifies the SCQBox component on a single view.
 * default value of `id` is 0
 *
 * @param {Object} props
 */

const SCQBox = (props) => {
  const {
    answer,
    formConf, //used if this component is wrapped with `<form>` element with submit input
    id = 0,
    onOptionSelect,
    optionConf,
    OptionsArr,
    questionStatement,
    readOnly,
  } = props;

  const inputChangeHandler = (e) => {
    let value = e.target.value;

    onOptionSelect(value, id);
  };

  const renderWidget = (value, caption, checked) => {
    return (
      <div className="SCQBox__widget-wpr col-6 col-lg" key={value}>
        <label className="SCQBox__label m-0">
          {checked && (
            <input
              checked
              disabled={readOnly}
              name={formConf ? formConf.name : "SCQBox" + id}
              onChange={inputChangeHandler}
              type="radio"
              value={value}
            />
          )}
          {!checked && (
            <input
              disabled={readOnly}
              name={formConf ? formConf.name : "SCQBox" + id}
              onChange={inputChangeHandler}
              type="radio"
              value={value}
            />
          )}
          <span className="SCQBox__mask" />
          <span className="SCQBox__value">{value}</span>
          <span className="SCQBox__caption fs-12 fs-lg-14">{caption}</span>
        </label>
      </div>
    );
  };

  return (
    <div className="SCQBox mb-4 mb-lg-5 pb-lg-3">
      <div>
        <p className="fs-16 tw:font-bold">{id + ". " + questionStatement}</p>
      </div>
      <div className="SCQBox__inner row no-gutters">
        {OptionsArr.map((choice) => {
          let checked = false;

          if (answer !== undefined && answer !== null) {
            checked = choice === Number(answer);
          }

          return renderWidget(optionConf[choice].value, optionConf[choice].caption, checked);
        })}
      </div>
    </div>
  );
};

SCQBox.propTypes = {
  formConf: PropTypes.object,
  id: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
  onOptionSelect: PropTypes.func.isRequired,
  optionConf: PropTypes.array.isRequired,
  questionStatement: PropTypes.string.isRequired,
};

SCQBox.defaultProps = {
  id: 0,
};

export default SCQBox;
